/**
 * manifest.js — ELYON-COMMAND-CENTER-V2-FOUNDATION-1 (§3.6)
 *
 * Runtime module manifest consumed by the shell's ModuleLoader/AppRouter
 * (ELYON-SHELL-FOUNDATION-1). The shell builds routes from `screens[]` and
 * redirects `/` to the first enabled module's `defaultRoute`.
 *
 * Routing note: AppRouter owns `/` as a redirect target (not a rendered
 * route), so the command center's screen lives at `/command-center` and
 * `defaultRoute` points there. When command-center is the first enabled
 * module in the tenant config (ELYON-DEMO-TENANT-CONFIG-1), `/` resolves to
 * this surface — the post-login landing.
 *
 * Enablement prereqs (handoff — see decisions.md §Shell-wiring):
 *   1. 'command-center' added to ModuleLoader SUPPORTED_MODULE_IDS (this PR).
 *   2. 'command-center' listed first in tenantConfig.enabled_modules
 *      (ELYON-DEMO-TENANT-CONFIG-1).
 */
export default {
  id: 'command-center',
  label: 'Command Center',
  icon: 'LayoutDashboard',
  path: '/command-center',
  defaultRoute: '/command-center',
  screens: [
    {
      path: '/command-center',
      // @vite-ignore required: without it Vite statically bundles CommandCenter
      // into the shell chunk. CommandCenter imports TenantContext (already in
      // shell chunk) → circular dep → "Cannot access 'A' before initialization"
      // TDZ crash in Layer.js. @vite-ignore makes this a true runtime-only import.
      component: () => import(/* @vite-ignore */ './screens/CommandCenter.jsx'),
      label: 'Command Center',
      icon: 'LayoutDashboard',
    },
  ],
  requiredPermissions: [],
  substrate_consumers: ['DataService', 'AEGIS', 'EventBus'],
};
